const prefix = 'paymentMethods';

export const GET_ALL = `${prefix}/GET_ALL`; 
export const SET_DEFAULT = `${prefix}/SET_DEFAULT`;
export const CREATE = `${prefix}/CREATE`;
export const DESTROY = `${prefix}/DESTROY`;
